import React from 'react'
import Navbar from '../components/Navbar'
import data from '../data/raisins.json'
import ProductCard from '../components/ProductCard'
import Footer from '../components/Footer'

const Raisins = () => {
    return (
        <>
            <Navbar />
            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-duration="1s">Raisins (Dried Grapes)
                        <span className="cl-theme"></span></h2>
                    </div>

                    <div className="row">
                        {
                            data?.map(item => {
                                return <ProductCard data={item} type="raisins" />
                            })
                        }
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}

export default Raisins